export default __webpack_public_path__ + "static/media/front.b301f40f.png";